import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";

import ControlAllDropdown from "./ControlAllDropdown.vue";
import ControlList from "./ControlList/ControlList.vue";
import ExtraSensorList from "./ExtraSensorList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolsPanel',
  setup(__props) {

const showToolsPage = ref(true);

return { __sfc: true,showToolsPage, ControlAllDropdown, ControlList, ExtraSensorList }
}

})